import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import DialogWithClose from './DialogWithClose';
import { Spinner } from './spinner/Spinner';

const useStyles = makeStyles({
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
});

type DetailDialogProps = {
  open: boolean;
  index?: number;
  maxItems: number;
  moveToNext?: () => void;
  moveToPrev?: () => void;
  onClose: () => void;
  actionsTopRight?: ReactElement;
  isLoading?: boolean;
  children: ReactNode;
};

const DetailDialog = ({
  open,
  index,
  maxItems,
  moveToNext,
  moveToPrev,
  onClose,
  actionsTopRight,
  isLoading,
  children,
}: DetailDialogProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const disablePagination = index !== undefined && index + 1 >= maxItems;

  return (
    <DialogWithClose
      open={open}
      onClose={onClose}
      maxWidth="xl"
      onlyCloseOnEscape
      actionsTopLeft={
        <>
          <Tooltip title={t('carsTable.prevPage')} placement="right">
            <span>
              <IconButton disabled={index === 0} onClick={moveToPrev}>
                <NavigateBefore />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t('carsTable.nextPage')} placement="right">
            <span>
              <IconButton disabled={disablePagination} onClick={moveToNext}>
                <NavigateNext />
              </IconButton>
            </span>
          </Tooltip>
        </>
      }
      actionsTopRight={actionsTopRight}
    >
      {isLoading ? (
        <div className={classes.spinnerContainer}>
          <Spinner isLoading size="large" />
        </div>
      ) : (
        children
      )}
    </DialogWithClose>
  );
};

export default DetailDialog;
